/** 値が入力されており0より大きい */
export default {
  validate(value: string | number | undefined | null): boolean {
    if (!value) {
      return false;
    }
    return Number(value) > 0;
  },
};
